import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@showclix-shared/Tooltip';

const size = {
  small: "tabs--small",
  medium: "tabs--medium",
  large: "tabs--large",
  xlarge: "tabs--xlarge",
}

export class Tab extends Component {
  onClick = (e) => {
    e.preventDefault();
    const { label, onClick } = this.props;
    onClick(label);
  }

  render(){
    const {
      onClick,
      props: {
        activeTab,
        label,
      },
    } = this;

    const Wrap = this.props.tooltip ? Tooltip : React.Fragment;
    const wrapProps = this.props.tooltip ? {
      tip: this.props.tooltip,
      place: "top",
    } : {};

    return(
      <Wrap {...wrapProps}>
        <button
          className="tabs__tab outline-none"
          role="tab"
          aria-selected={activeTab === label ? "true" : "false"}
          aria-controls={`${this.props.label}-tab`}
          id={this.props.label}
          disabled={this.props.disabled}
          onClick={onClick}
          tabIndex={activeTab === label ? '0' : '-1'}
        >
          { this.props.iconBefore &&
            <i className={`${this.props.iconBefore} tabs__icon--before`} aria-hidden="true"></i>
          }
          {this.props.title}
          { this.props.iconAfter &&
            <i className={`${this.props.iconAfter} tabs__icon--after`}aria-hidden="true"></i>
          }
        </button>
      </Wrap>
    )
  }
}

class Tabs extends Component {
    static Tab = Tab;

    constructor(props) {
      super(props);
      this.state = {
        activeTab: props.openToTab ?? this.props.children[0].props.label,
      };
    }

    // Open Panels when Tabs clicked
    onClickTabItem = (tab) => {
      this.setState({ activeTab: tab });
      if (typeof this.props.onTabSelected === 'function') {
        this.props.onTabSelected(tab);
      }
    }

    componentDidMount () {
      this.tabKeyboarding();
    }

    render() {
      const {
        onClickTabItem,
        props: {
          children,
        },
        state: {
          activeTab,
        }
      } = this;
        return (
          <div className={`tabs ${this.props.size}`}>
            <div className="tabs__list" role="tablist" aria-label={this.props.label}
                 style={ this.props.backgroundColor ? { backgroundColor: this.props.backgroundColor} : {}} >
              {children.map((child) => {
                const { label, title, iconBefore, iconAfter, disabled, tooltip } = child.props;
                return (
                  <Tab
                    title={title}
                    label={label}
                    iconBefore={iconBefore}
                    iconAfter={iconAfter}
                    disabled={disabled}
                    key={label}
                    activeTab={activeTab}
                    onClick={onClickTabItem}
                    tooltip={tooltip}
                  />
                );
              })}
            </div>
            <div id="tabs__panel">
              {children.map((child) => {
                const { label } = child.props;
                if (child.props.label !== activeTab) return undefined;
                return (
                  <div
                    className="tabs__panel"
                    role="tabpanel"
                    id={`${label}-tab`}
                    aria-labelledby={label}
                    hidden={!activeTab}
                    key={`${label}-tab`}
                  >
                    {child.props.children}
                  </div>
                )
              })}
            </div>
          </div>
        );
    }

    // Detect Keyboard use, use arrow keys to focus Tabs
    tabKeyboarding = () => {
      // find all tabs and make an array;
      var tabs = document.querySelectorAll('[role="tab"]:enabled');
      var i;
      for (i = 0; i < tabs.length; ++i) {
        addListeners(i);
      };

      function addListeners (index) {
        tabs[index].addEventListener('keydown', keydownEventListener);
        // Build an array with all tabs in it
        tabs[index].index = index;
      };

      // Handle keydown on Tabs
      function keydownEventListener (event) {
        var target = event.target;
        switch (event.key) {
          case "Shift" && "Tab":
            // act normally
            break;
          case "Tab":
            event.preventDefault();
            document.getElementById('tabs__panel').focus();
            break;
          case "Right": // IE/Edge
          case "ArrowRight":
            event.preventDefault();
            if (target.index === (tabs.length - 1)) {
              return;
            } else {
              tabs[(target.index + 1)].focus();
            }
            break;
          case "Left": // IE/Edge
          case "ArrowLeft":
            event.preventDefault();
            if (target.index === 0 ) {
              return;
            } else {
              tabs[(target.index - 1)].focus();
            }
            break;
        };
      };
    }
}

Tabs.size = size;

Tabs.defaultProps = {
    size: Tabs.size.small,
    backgroundColor: null,
}

Tabs.propTypes = {
    children: PropTypes.any.isRequired,
    size: PropTypes.oneOf(Object.values(size)),
    backgroundColor: PropTypes.string,
    onTabSelected: PropTypes.func,
    openToTab: PropTypes.string,
}

Tab.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  iconBefore: PropTypes.string,
  iconAfter: PropTypes.string,
  disabled: PropTypes.bool,
}



export default Tabs;
